import { message } from 'antd'
import { axiosInstance } from '../../../hooks/useAxios'
import { Box, Dialog, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import { ERRORS_MESSAGE_MAPPER } from '../../../constants/errors'

interface IUserFormResetPasswordModalProps {
  isOpen: boolean;
  onClose: (visible: boolean) => void;
  username: string;
  onUpdateUserSuccess: () => void;
}

interface IUserFormResetPasswordModal {
  newPassword: string;
  confirmPassword: string;
}

const getUserResetPasswordFormValidationSchema = () => {
  return Yup.object({
    newPassword: Yup.string().required('กรุณากรอกรหัสผ่านใหม่').matches(/^[a-zA-Z0-9]+$/, 'กรุณากรอกชื่อผู้ใช้งานเฉพาะภาษาอังกฤษและตัวเลขเท่านั้น').min(6, 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร'),
    confirmPassword: Yup.string().required('กรุณากรอกรหัสผ่านใหม่อีกครั้ง').oneOf([Yup.ref('newPassword'), null!], 'รหัสผ่านไม่ตรงกัน'),
  })
}

export const UserFormResetPasswordModal = (props: IUserFormResetPasswordModalProps) => {
  const { isOpen, onClose, username, onUpdateUserSuccess } = props

  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: getUserResetPasswordFormValidationSchema(),
    onSubmit: async (values: IUserFormResetPasswordModal) => {
      try {
        await axiosInstance.put(
          `/users/changepassword/${username}`,
          {
            newPassword: values.newPassword,
            confirmPassword: values.confirmPassword,
          },
        )
        message.success('เปลี่ยนรหัสผ่านสำเร็จ')
        onClose(false)
        formik.resetForm()
        onUpdateUserSuccess()
      } catch (e: any) {
        const messageError = ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] || 'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
    },
  })

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} maxWidth="md">
      <DialogTitle>เปลี่ยนรหัสผ่าน</DialogTitle>
      <DialogContent>
        <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} lg={12}>
              <TextField
                type={'password'}
                id="newPassword"
                fullWidth
                label="กรอกรหัสผ่านใหม่"
                name="newPassword"
                helperText={
                  formik.touched.newPassword && formik.errors.newPassword as string
                }
                error={
                  !!(formik.touched.newPassword && formik.errors.newPassword)
                }
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.newPassword}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <TextField
                type={'password'}
                id="confirmPassword"
                fullWidth
                label="กรอกรหัสผ่านอีกครั้ง"
                name="confirmPassword"
                helperText={
                  formik.touched.confirmPassword && formik.errors.confirmPassword as string
                }
                error={
                  !!(formik.touched.confirmPassword && formik.errors.confirmPassword)
                }
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.confirmPassword}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2} justifyContent={'flex-end'}>
            <Grid item>
              <Button
                startIcon={<SaveIcon />}
                color="primary"
                type="submit"
                size="large"
                variant="contained"
              >
                เปลี่ยนรหัสผ่าน
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="inherit"
                size="large"
                variant="contained"
                onClick={() => onClose(false)}
                startIcon={<ClearIcon />}
              >
                ปิดหน้าต่าง
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
